import './ParameterDisplay.scss';
import { ParameterModel } from 'types/trackmanParameters';
import ArticlesInfo from '../../ArticlesInfo/ArticlesInfo';
import ParameterDefinition from '../../ParameterDefinition/ParameterDefinition';
import ParameterVideos from '../../ParameterVideos/ParameterVideos';
import TourAveragesTable from '../../TourAveragesTable/TourAveragesTable';
import TrackmanParameterImage from '../../TrackmanParameterImage/TrackmanParameterImage';
import UsageInfo from '../../UsageInfo/UsageInfo';
import { useState } from 'react';

type ParameterDisplayProps = {
  parameter: ParameterModel | undefined;
};

export const ParameterDisplay = ({ parameter }: ParameterDisplayProps) => {
  const [visibleVideoUrl, setVisibleVideoUrl] = useState<string>('');
  const visibleVideo = parameter?.videoUrls.find((video) => video.videoUrl === visibleVideoUrl) || parameter?.videoUrls[0] || null;

  return (
    <div className='trackman-parameters-content'>
      {parameter && (
        <div className='parameter-content-box'>
          <ParameterDefinition visibleParameter={parameter} />
          <TrackmanParameterImage visibleParameter={parameter} />
          <div className='parameter-details'>
            {parameter.usageInfo && <UsageInfo visibleParameter={parameter} />}
            {parameter.averageTourData && <TourAveragesTable visibleParameter={parameter} />}
            {visibleVideo && (
              <ParameterVideos visibleParameter={parameter} visibleVideo={visibleVideo} setVisibleVideo={(v) => setVisibleVideoUrl(v.videoUrl)} />
            )}
            {parameter.articlesInfo && <ArticlesInfo visibleParameter={parameter} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default ParameterDisplay;
